import './LoaderCircle.style.scss'
export const LoaderCircle = () => {
  return (
    <div class="lds-ripple"><div></div><div></div></div>
  )
}